import { page, shows, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  shell: [
    { path: "cards/:cardId", lazy: page(() => import("./CardDetailPage")), handle: shows("cards", "market") },
  ],
};
